import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	data: [],
	selectedActivation: null,
	page: 1,
	perPage: 10,
	totalItems: 0,
	totalPage: 0,
	loading: false,
	loadingDetails: false,
};

const activationSlice = createSlice({
	name: "auth/user",
	initialState,
	reducers: {
		setActivationLoading: (state, action) => {
			state.loading = action.payload;
		},
		setActivationData: (state, action) => {
			const { data, totalItems, page, perPage } = action.payload;
			state.data = data || [];
			state.totalItems = totalItems || 0;
			state.page = page || 1;
			state.perPage = perPage || 10;
			state.totalPage = Math.ceil(totalItems / perPage);
			state.loading = false;
		},
		setSelectedActivation: (state, action) => {
			state.selectedActivation = action.payload;
		},
		setDetailsLoading: (state, action) => {
			state.loadingDetails = action.payload;
		},
	},
});

export const { setActivationLoading, setActivationData, setSelectedActivation, setDetailsLoading } =
	activationSlice.actions;

export default activationSlice.reducer;
